// 性別
export const SexTypes = {
    Man: '男性',
    Woman: '女性',
    None: ''
} as const;
export type Sex = typeof SexTypes[keyof typeof SexTypes];

// 血液型
export const bloodTypes = {
    A: "A",
    B: "B",
    AB: "AB",
    O: "O",
    unknown: "不明"
} as const;
export type BloodType = typeof bloodTypes[keyof typeof bloodTypes];

export function getBloodTypeSelects(): string[] {
    const types = []
    // もちろん反復処理可能
    for (const bloodType of Object.values(bloodTypes)) {
        types.push(bloodType);
    }
    return types;
}

// お酒を飲むか
export const isDrinkTypes = {
    Want: '飲む',
    Can: '飲める',
    Not: '飲めない',
    None: ''
} as const;
export type IsDrinkType = typeof isDrinkTypes[keyof typeof isDrinkTypes];

export function getIsDrinkTypeSelects(): string[] {
    const types = []
    // もちろん反復処理可能
    for (const isDrinkType of Object.values(isDrinkTypes)) {
        if (isDrinkTypes.None == isDrinkType) {
            continue;
        }
        types.push(isDrinkType);
    }
    return types;
}

// タバコを吸うか
export const isSmokeTypes = {
    Always: '吸う',
    SomeTime: 'たまに吸う',
    Not: '吸わない',
    None: ''
} as const;
export type IsSmokeType = typeof isSmokeTypes[keyof typeof isSmokeTypes];

export function getIsSmokeTypeSelects(): string[] {
    const types = []
    // もちろん反復処理可能
    for (const isSmokeType of Object.values(isSmokeTypes)) {
        if (isSmokeTypes.None == isSmokeType) {
            continue;
        }
        types.push(isSmokeType);
    }
    return types;
}

// ユーザータイプ
export const UserTypes = {
    Guest: 'guest',
    Cast: 'cast',
    None: ''
} as const;
export type UserType = typeof UserTypes[keyof typeof UserTypes]; // 'guest' | 'cast' | ''

// 利用シーン
export const SceneTypes = {
    Reception: '接待',
    Provate: 'プライベート',
    Quiet: 'しっぽり',
    Getup: 'わいわい',
} as const;
export type SceneType = typeof SceneTypes[keyof typeof SceneTypes];

// 特徴
export const FeatureTypes = {
    Babyface: '童顔',
    Pretty: '綺麗め',
    Tall: '身長高め',
    Short: '身長低め',
} as const;
export type FeatureType = typeof FeatureTypes[keyof typeof FeatureTypes];

// 口座情報
export const AccountTypes = {
    Ordinary: '普通',
    Current: '当座',
} as const;
export type AccountType = typeof AccountTypes[keyof typeof AccountTypes];

export interface bankAccount {
    bankName: string,
    bankBranch: string,
    accountType: AccountType | null,
    accountNumber: string,
    accountName: string,
}